import React from 'react';
export const Header = () => {
  return <header className="border-b border-gray-200 pb-2" data-id="element-69">
      <div className="px-4 md:px-8 pt-4" data-id="element-70">
        <div className="text-xs text-center text-gray-500 mb-2" data-id="element-71">
          Advertorial
        </div>
        <div className="flex items-start mb-2" data-id="element-72">
          <a href="https://petssey.com/products/petssey-dnrx" className="inline-block" data-id="element-73">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pN6xiGVkwr2TEwDipfvhWD/petssey_%281%29.png" alt="Petssey Logo" className="w-2/5 object-contain" data-id="element-74" />
          </a>
        </div>
        <div className="border-t border-gray-200 my-2" data-id="element-75"></div>
        <h1 className="text-[32px] md:text-3xl font-semibold text-center text-gray-900 mb-2 leading-[1.2]" data-id="element-76">
          How This Australian Cat Mum Effortlessly Eliminated Cat Dander from
          Her Home in Just 30 Minutes
        </h1>
        <div className="border-t border-gray-200 my-2" data-id="element-77"></div>
        <p className="text-center text-sm text-gray-500 mb-2" data-id="element-78">
          26th January, 2025
        </p>
      </div>
    </header>;
};